export default {
	mainContainer: {
		display: 'flex',
		gap: '30px'
	},
	leftContainer: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		gap: '20px'
	},
	leftContainerHeader: {
		display: 'flex',
		flexDirection: 'column',
		gap: '10px'
	},
	progressSubLabels: {
		display: 'flex',
		justifyContent: 'space-between',
		alignContent: 'center'
	},
	sectionHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center'
	},
	sectionStyle: {
		background: '#fff',
		padding: '20px'
	},
	sectionColumn: {
		display: 'flex',
		flexDirection: 'column',
		gap: '20px'
	},
	fontBold: {
		fontWeight: 'bold',
	},
	flexOne: {
		flex: 1
	},
	payerColumn: {
		display: 'flex',
		justifyContent: 'space-between',
		flexDirection: 'column'
	},
	documentBody: {
		display: 'flex',
		gap: '20px',
		alignItems: 'center'
	},
	popupCustomStyle: {
		maxHeight: "95vh",
		display: "flex",
		flexDirection: "column",
		width: '50vw',
		maxWidth: '50vw',
		minHeight: '200px'
	},
	minHeight200: {
		minHeight: '200px'
	},
	height200: {
		height: '200px'
	},
	popupChildrenStyles: {
		maxHeight: "100%",
		padding: '50px',
		paddingTop: '10px',
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		justifyContent: 'space-between',
		flex: 1,
	},
	displayNone: {
		display: 'none'
	},
	addNotePopupField: {
		display: 'flex',
		gap: '20px',
		height: '80%'
	},
	fullWidth: {
		width: '100%'
	},
	addTaskPopupField: {
		display: 'flex',
		flexDirection: 'column',
		gap: '20px'
	},
	clientPopupField: {
		display: 'flex',
		gap: '20px'
	},
	taskHearder: {
		alignItems: 'center',
		width: '100%',
		display: 'grid',
		gridTemplateColumns: '2fr 1fr 1fr 1fr',
		columnGap: '10px'
	},
	ellipsisBox: {
		display: 'flex',
		justifyContent: 'flex-end',
	},
	taskBody: {
		display: 'flex',
		flexDirection: 'column',
		gap: '20px'
	},
	taskBodyAddRows: {
		display: 'flex',
		gap: '20px'
	},
	taskSection: {
		display: 'flex',
		flexDirection: 'column',
		gap: '20px'
	},
	popupFooterButton: {
		display: 'flex',
		gap: '10px',
		alignItems: 'center',
		justifyContent: 'flex-end',
		paddingTop: '20px'
	},
	colorBlack: {
		color: 'black'
	},
	cursorPointer: {
		cursor: 'pointer'
	}
}